import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react'
import Swiper from 'swiper'

import {
  ExerciseStep,
  ExerciseType,
  OnResponseSubmit,
  StepResponse,
} from '../../../types/Exercise'
import InteractionBase from '../../../common/components/InteractionBase'
import StepsNavigation from '../../../common/components/InteractionBase/StepsNavigation'
import { useFeedStore } from '../../../store/feed-store'
import ExerciseComponent from './ExerciseComponent'

interface MultipleStepsProps {
  exercises: ExerciseStep[]
  onResponseSubmit: OnResponseSubmit
  stepResponses?: StepResponse[]
}

const MultipleSteps = ({
  exercises,
  onResponseSubmit,
  stepResponses,
}: MultipleStepsProps) => {
  const { setCurrentStep } = useFeedStore()

  const handleSlideChange = (swiper: Swiper) => {
    setCurrentStep(swiper.activeIndex + 1)
  }

  return (
    <ReactSwiper
      style={{ height: '100dvh', position: 'relative' }}
      spaceBetween={30}
      keyboard
      onSlideChange={handleSlideChange}
      watchSlidesProgress
    >
      {exercises.length && <StepsNavigation numberOfSteps={exercises.length} />}
      {exercises.map((exercise) => {
        const { id, title, header: questionTitle, context } = exercise
        return (
          <SwiperSlide key={id} style={{ height: '100%' }}>
            <InteractionBase
              title={title}
              questionTitle={questionTitle}
              context={context}
              isExercise
              hasStepDisplay
              isSocialMedia={exercise.type === ExerciseType.SOCIAL_MEDIA}
            >
              <ExerciseComponent
                exercise={exercise}
                onResponseSubmit={onResponseSubmit}
                stepResponses={stepResponses}
              />
            </InteractionBase>
          </SwiperSlide>
        )
      })}
    </ReactSwiper>
  )
}

export default MultipleSteps
